import { InteractiveControl, ControlSet } from './interactive-control';

const resizeCursorMap: Record<string, CSSStyleDeclaration['cursor']> = {
  tl: 'nwse-resize',
  tr: 'nesw-resize',
  bl: 'nesw-resize',
  br: 'nwse-resize',
  ml: 'ew-resize',
  mr: 'ew-resize',
  mt: 'ns-resize',
  mb: 'ns-resize',
  mtr: 'crosshair',
};

const baseControl = (key: string, overrides: Partial<InteractiveControl>): InteractiveControl =>
  new InteractiveControl({ cursorStyle: resizeCursorMap[key] || 'crosshair', ...overrides });

/**
 * Creates the default set of object controls (8 corners + rotation)
 */
export const createDefaultControls = (): ControlSet => ({
  tl: baseControl('tl', { x: -0.5, y: -0.5 }),
  tr: baseControl('tr', { x: 0.5, y: -0.5 }),
  bl: baseControl('bl', { x: -0.5, y: 0.5 }),
  br: baseControl('br', { x: 0.5, y: 0.5 }),
  ml: baseControl('ml', { x: -0.5, y: 0 }),
  mr: baseControl('mr', { x: 0.5, y: 0 }),
  mt: baseControl('mt', { x: 0, y: -0.5 }),
  mb: baseControl('mb', { x: 0, y: 0.5 }),
  mtr: new InteractiveControl({
    x: 0,
    y: -0.5,
    offsetY: -40,
    withConnection: true,
    cursorStyle: 'crosshair',
  }),
});
